// extracted by mini-css-extract-plugin
module.exports = {"orderProduct":"hn","cancellationReason":"in"};